import React from 'react';
import { type InventoryDetailsPublicDataFragment } from '../../../../../api/fragments/InventoryDetailsPublicData';
import { BoxOption, Container } from './ui';

type OptionBoxFieldProps = {
    selectedId: string;
    options: {
        id: string;
        image: string;
        color: string;
        name: string;
    }[];
    onClick: (value: string) => void;
    inventoryList: InventoryDetailsPublicDataFragment[];
    filteredStockInventoryBySelectedSection: InventoryDetailsPublicDataFragment[];
};

export const OptionBoxField = ({
    options,
    selectedId,
    onClick,
    inventoryList,
    filteredStockInventoryBySelectedSection,
}: OptionBoxFieldProps) => (
    <Container>
        {options.map(item => {
            const availableStock = inventoryList.some(
                stock =>
                    stock.__typename === 'ConfiguratorInventory' &&
                    stock.availableStock > 0 &&
                    stock.trimSetting.id === item.id
            );

            if (!availableStock) {
                return null;
            }

            const disabledSetting = filteredStockInventoryBySelectedSection.some(
                stock =>
                    stock.__typename === 'ConfiguratorInventory' &&
                    stock.availableStock > 0 &&
                    stock.trimSetting.id === item.id
            );

            return (
                <BoxOption
                    key={item.name}
                    availableStock={disabledSetting}
                    item={item}
                    onClick={onClick}
                    selectedId={selectedId}
                />
            );
        })}
    </Container>
);

export default OptionBoxField;
